import React, { Fragment, useState, useEffect } from "react";
import moment from "moment";
import * as style from "./styles.module.scss";
import HorizontalLine from "../../common/HorizontalLine/index";
import Spinner from "../../common/Spinner/index";

const HolidayRequest = ({
  postHolidayRequestForm,
  holidayRequestFormLoading,
  holidayRequestFormSubmitted,
  permissions,
  errors,
}) => {
  const holidayRequestError =
    errors && errors.filter((error) => error.source === "postHolidayRequest");

  const getFailedPostRequestMessage = () => {
    if (holidayRequestError && holidayRequestError.length > 0) {
      return holidayRequestError[0].error;
    }
    return "Holiday request has not been sent! Try again!";
  };
  const Alert = ({ message, styling }) => (
    <div className={`${style.alert} ${styling} text-center`} role="alert">
      {message}
    </div>
  );

  // Thanet District Council candidates have a two weeks notice instead of one week
  const { isThanetCouncil } = permissions || false;

  const [holidayFormData, setHolidayFormData] = useState({
    startDate: "",
    endDate: "",
    notes: "",
  });

  const [errorMessage, setErrorMessage] = useState({
    startDate: "",
    endDate: "",
  });

  const checkForErrors = () => {
    let error = false;
    const possibleStartDate = moment()
      .add(isThanetCouncil ? 14 : 7, "days")
      .format("YYYY-MM-DD");

    const { startDate, endDate } = holidayFormData;

    const startInputDate = startDate
      ? moment(startDate).format("YYYY-MM-DD")
      : null;
    const endInputDate = endDate ? moment(endDate).format("YYYY-MM-DD") : null;

    if (moment(startInputDate).isBefore(possibleStartDate)) {
      setErrorMessage({
        ...errorMessage,
        startDate: `Date must be a minimum of ${
          isThanetCouncil ? "two weeks" : "one week"
        } from today’s date.`,
      });
      error = true;
    }

    if (moment(endInputDate).isBefore(startDate)) {
      setErrorMessage({
        ...errorMessage,
        endDate: "The end date cannot be before the start date.",
      });
      error = true;
    }
    return error;
  };

  const handleHolidayFormRequest = async () => {
    const determineEndDate = () =>
      holidayFormData.endDate === ""
        ? moment(holidayFormData.startDate).format("DD/MM/YYYY")
        : moment(holidayFormData.endDate).format("DD/MM/YYYY");

    const dataToSubmit = {
      notes: holidayFormData.notes,
      date: moment(holidayFormData.startDate).format("DD/MM/YYYY"),
      endDate: determineEndDate(),
    };

    const error = await checkForErrors();

    if (!error) {
      postHolidayRequestForm(dataToSubmit);
      setHolidayFormData({
        startDate: "",
        endDate: "",
        notes: "",
      });
    }
  };

  return (
    <div className={"container pb-1"}>
      <div className={"row"}>
        <div className={style.cardStylesHoliday}>
          <div className={style.cardStylesHolidayBackground}>
            <div className={style.cardStylesHolidayWrapper}>
              <div className={`p-1 ${style.holidayTextBackground}`}>
                <p>
                  At least {isThanetCouncil ? "two weeks" : "one week"} notice
                  must be given. For further details, please speak to your HRGO
                  consultant.
                </p>
                <p>
                  Please note that submitting this holiday request does not mean
                  it has been approved, you must wait for your branch to confirm
                  approval with you.
                </p>
              </div>
              <div className={`p-1 ${style.holidayFormBackground}`}>
                <form>
                  <Fragment>
                    <div className="form-row">
                      <div className="form-group col-md-3">
                        <label
                          htmlFor="holidayFormDate"
                          className="font-weight-bold"
                        >
                          Start date
                        </label>
                        <input
                          type="date"
                          value={holidayFormData.startDate}
                          onChange={(e) => {
                            setHolidayFormData({
                              ...holidayFormData,
                              startDate: e.target.value,
                            });
                          }}
                          className="form-control"
                          id="holidayFormDate"
                          min={moment()
                            .add(isThanetCouncil ? 14 : 7, "days")
                            .format("YYYY-MM-DD")}
                        />
                        <p className={style.inputErrorMessage}>
                          {errorMessage.startDate}
                        </p>
                      </div>
                      <div className="form-group col-md-3">
                        <label
                          htmlFor="holidayFormDate"
                          className="font-weight-bold"
                        >
                          End date
                        </label>
                        <input
                          type="date"
                          value={holidayFormData.endDate}
                          onChange={(e) => {
                            setHolidayFormData({
                              ...holidayFormData,
                              endDate: e.target.value,
                            });
                          }}
                          className="form-control"
                          id="holidayFormDate"
                          min={moment()
                            .add(isThanetCouncil ? 14 : 7, "days")
                            .format("YYYY-MM-DD")}
                        />
                        <p className={style.inputErrorMessage}>
                          {errorMessage.endDate}
                        </p>
                      </div>
                      <div className="form-group col-md-6">
                        <label
                          htmlFor="holidayFormNotes"
                          className="font-weight-bold"
                        >
                          Notes
                        </label>
                        <input
                          type="text"
                          value={holidayFormData.notes}
                          onChange={(e) => {
                            setHolidayFormData({
                              ...holidayFormData,
                              notes: e.target.value,
                            });
                          }}
                          className="form-control"
                          id="holidayFormNotes"
                        />
                      </div>
                    </div>
                  </Fragment>
                  {holidayRequestFormSubmitted && (
                    <Alert
                      message="Holiday request has been sent!"
                      styling={style.alertSuccess}
                    />
                  )}
                  {holidayRequestFormSubmitted === false && (
                    <Alert
                      message={getFailedPostRequestMessage()}
                      styling={style.alertError}
                    />
                  )}
                  <div className="d-flex justify-content-md-end mb-1">
                    <button
                      type="button"
                      className={`btn btn-primary ${style.submitBtn}`}
                      onClick={() => {
                        handleHolidayFormRequest(holidayFormData);
                      }}
                    >
                      Send Request {holidayRequestFormLoading && <Spinner />}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HolidayRequest;
